/* eslint-disable */
import moment from 'moment';
import 'moment/locale/ru';
import setAdditionalMetaOptions from '@/js/common/Domain/Service/setAdditionalMetaOptions';
import './priceCalendar.scss';
import AjaxRequestManager from '../../Domain/AjaxRequestManager';
import tourCriteriaJsonHydrator from '../../Domain/Hydrator/tourCriteriaJson';
import CheckInDateRangeFactory from '../../Domain/Factory/CheckInDateRange';
import tourCriteriaService from '../../Domain/Service/tourCriteria';
import CheckInDateRangeObjectValue from '../../Domain/ObjectValue/CheckInDateRange';
import DataLayerAnalytics from '@/js/common/Domain/Service/DataLayerAnalytics';

const ajaxRequestManager = new AjaxRequestManager();

const PriceCalendarModel = Backbone.Epoxy.Model.extend({
    defaults: {
        searchData: null,
        selectedDates: null,
        calendarData: null,
        offset: 0,
        emptyDates: [],
        addCollToSlide: 8,
        mobileViewDateCheck: false,
        mobileTourInfoPrice: false,
    },
    numOfCalendarDays: 31,
    computeds: {
        calendarMinPrice: function () {
            const currentPrices = this.get('calendarData');
            if (currentPrices && currentPrices.length) {
                return _.min(_.pluck(currentPrices, 'price'), function (price) {
                    return _.isNull(price) || !price ? Infinity : price;
                });
            }
            return false;
        },
        calendarMaxPrice: function () {
            const currentPrices = this.get('calendarData');
            if (currentPrices && currentPrices.length) {
                return _.max(_.pluck(currentPrices, 'price'));
            }
            return false;
        },
        nightsLabel: function () {
            const searchData = this.get('searchData');
            const nights = searchData ? searchData.get('nightRange') : null;
            const nightsFrom = nights ? nights.get('from') : null;
            const nightsTo = nights ? nights.get('to') : null;
            let label = '';

            if (searchData && nights && nightsFrom && nightsTo) {
                if (nightsFrom === nightsTo) {
                    label = nightsTo + ' ноч' + nightsTo.wordEnding('ь;и;ей');
                } else {
                    label = nightsFrom + '-' + nightsTo + ' ноч' + nightsTo.wordEnding('ь;и;ей');
                }
            }

            return label;
        },
        touristLabel: function () {
            if (!this.get('searchData')) return false;

            const searchData = this.get('searchData');
            const touristGroup = searchData.get('touristGroup').toJSON();
            let text = 'при размещении ';
            const kids = touristGroup.infants + touristGroup.kids;
            text += touristGroup.adults + ' взросл' + touristGroup.adults.wordEnding('ого;ых;ых');
            if (kids) {
                text += ' и ' + kids + ' ' + kids.wordEnding('ребенка;детей;детей');
            }

            return text;
        },
        expandedDatesObject: function () {
            const searchData = this.get('searchData');
            const { numOfCalendarDays } = this;
            const offset = this.get('offset');
            const addCollToSlide = this.get('addCollToSlide');
            let checkInDateRange;
            let dateFrom;
            let currentDate;
            let dateTo;
            let needDates;
            let datesDiff;
            let needDatesDiff;
            let dateFromDiff;
            let dateToDiff;

            function checkScrollNumberInDate(number) {
                let ceilNumber = Math.ceil(number);
                if (ceilNumber > addCollToSlide && ceilNumber % addCollToSlide !== 0) {
                    ceilNumber++;
                    checkScrollNumberInDate(ceilNumber);
                }
                return ceilNumber;
            }

            if (searchData) {
                checkInDateRange = searchData.get('checkInDateRange');
                dateFrom = moment(checkInDateRange.get('from'));
                currentDate = moment().add(1, 'days').startOf('day');
                dateTo = moment(checkInDateRange.get('to'));
                needDates = numOfCalendarDays - 1;
                datesDiff = dateTo.diff(dateFrom, 'days');
                needDatesDiff = needDates - datesDiff;
                dateFromDiff = Math.floor(needDatesDiff / 2);
                dateToDiff = dateFromDiff + (needDatesDiff % 2);

                dateFrom.subtract(dateFromDiff, 'days');
                dateTo.add(dateToDiff, 'days');

                if (dateFrom.diff(currentDate, 'days') < 0) {
                    dateFrom = currentDate.clone();
                    dateTo = currentDate.clone().add(needDates, 'days');
                }

                dateFrom = dateFrom.add(checkScrollNumberInDate(offset * numOfCalendarDays), 'days');
                dateTo = dateTo.add(checkScrollNumberInDate(offset * numOfCalendarDays), 'days');

                return {
                    from: dateFrom,
                    to: dateTo,
                };
            }

            return null;
        },
        expandedDates: function () {
            const expandedDatesObject = this.get('expandedDatesObject');

            if (expandedDatesObject) {
                return {
                    from: expandedDatesObject.from.toDate(),
                    to: expandedDatesObject.to.toDate(),
                };
            }

            return null;
        },
        prevDatesAvailable: function () {
            const currentDate = moment().add(1, 'days').startOf('day');
            const expandedDatesObject = this.get('expandedDatesObject');
            return expandedDatesObject && expandedDatesObject.from.diff(currentDate, 'days') > 0;
        },
    },
});

const PriceCalendarView = Backbone.Epoxy.View.extend({
    ajaxRequestManager: ajaxRequestManager,
    el: '<div id="priceCalendar" class="calendar-lp-serp" style="display:none">\n\t<div class="calendar-lp-serp__header-title">\n\t\tКалендарь низких цен\n\t</div>\n\t<div class="calendar-lp-serp__header-info">\n\t\tВсе цены указаны <span class="touristLabel"></span> на <span class="nightsLabel"></span>\n\t</div>\n\t<div class="calendar-lp-serp__container">\n\t\t<div class="calendar-lp-serp__container-inset">\n\t\t\t<div class="cls__nav-left">\n\t\t\t\t<i class="icon-i16_arrow-left"></i>\n\t\t\t</div>\n\t\t\t<div class="cls__nav-right">\n\t\t\t\t<i class="icon-i16_arrow-right"></i>\n\t\t\t</div>\n\t\t\t<div class="calendar-lp-serp__container-inset-two">\n\t\t\t\t<div class="cls__shore-left">\n\t\t\t\t\t<div class="cls__shore-left-line-value min minPriceThing"><span class="priceLabelMin"></span> <span class="rubl">a</span></div>\n\t\t\t\t\t<div class="cls__shore-left-line-value max maxPriceThing"><span class="priceLabelMax"></span> <span class="rubl">a</span></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="cls__shore-right"></div>\n\t\t\t\t<div class="calendar-lp-serp__container-inset-three">\n\t\t\t\t\t<div class="cls__i-three-upstairs-line min minPriceThing"></div>\n\t\t\t\t\t<div class="cls__i-three-upstairs-line max maxPriceThing"></div>\n\t\t\t\t\t<div class="cls__i-three-upstairs calendarData"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>',
    calendarDataTemplate: _.template('<div class="cls-itu-range">\n    <% var datesAmount = calendarData.length,\n    \tselectedDate = selectedDates.get(\'from\').getTime() == selectedDates.get(\'to\').getTime() ? selectedDates.get(\'from\'): 0;\n    %>\n\n    <%_.each(calendarData, function(dateData, index) { %>\n    \n    <div class="cls-itu-column<%= !today.diff(dateData.date) ? \' disabled\' : \'\'%> <%= !dateData.price ? \' not-price\' : \'\'%><%=selectedDate && selectedDate.getTime() == dateData.date._d.getTime()  ? \' current\' : \'\' %>" data-date="<%=dateData.date.format(\'YYYY-MM-DD\') %>" data-price="<%=dateData.price.formatNumber()%>">\n        <div class="cls-display">\n            <% if(dateData.price) { %>\n            <% var percent = (calendarMaxPrice != calendarMinPrice) ? ((dateData.price -\n            calendarMinPrice)*100/(calendarMaxPrice - calendarMinPrice)) : 50;\n            var columnType = "";\n            if(dateData.price == calendarMinPrice){\n            columnType = "cls-col-minPrice"\n            }else if(dateData.price == calendarMaxPrice){\n            columnType = "cls-col-maxPrice"\n            }\n            %>\n\n            <div class="cls-d-ind <%=columnType%>" style="height:<%=percent%>%;">\n                <div class="cls-d-ind__tip">\n                    От <%=dateData.price.formatNumber() %> <span class="rubl">a</span>\n                </div>\n            </div>\n            <% } else { %>\n\t\t\t\n            <div class="cls-d-no-price  <%= ~emptyDates.indexOf(dateData.date.format(\'YYYY-MM-DD\')) ? \'cls-d-have-not-tours\' : \'\'%>"></div>\n            <% } %>\n        </div>\n        <div class="cls-value<%=_.contains([6,7], parseInt(dateData.date.format(\'E\'), 10)) ? \' weekend\' : \'\' %>">\n            <%=dateData.date.format(\'D\') %>, <%=dayOfWeek[dateData.date.format(\'e\')] %>\n        </div>\n    </div>\n\n    \n    <% if(index < (datesAmount-1)) { %>\n    <% if(dateData.date.format(\'M\') != calendarData[index+1].date.format(\'M\')) { %>\n    <div class="cls-itd-range-label"><span><%=dateData.date.format(\'MMMM\') %></span></div>\n</div>\n<div class="cls-itu-range">\n    <% } %>\n    <% } else if(index == (datesAmount-1)) { %>\n    <div class="cls-itd-range-label"><span><%=dateData.date.format(\'MMMM\') %></span></div>\n    <% } %>\n    <% }) %>\n</div>'),
    model: null,
    searchViewModel: null,
    preventSearchDataUpdate: false,
    $nightsLabel: function () {
        this.$nightsLabel = $('.nightsLabel', this.$el);
    },
    $touristLabel: function () {
        this.$touristLabel = $('.touristLabel', this.$el);
    },
    $minPriceLabel: function () {
        this.$minPriceLabel = $('.priceLabelMin', this.$el);
    },
    $minPriceThing: function () {
        this.$minPriceThing = $('.minPriceThing', this.$el);
    },
    $maxPriceThing: function () {
        this.$maxPriceThing = $('.maxPriceThing', this.$el);
    },
    $maxPriceLabel: function () {
        this.$maxPriceLabel = $('.priceLabelMax', this.$el);
    },
    $calendarData: function () {
        this.$calendarData = $('.calendarData', this.$el);
    },
    $previousDates: function () {
        this.$previousDates = $('.cls__nav-left .icon-i16_arrow-left', this.$el);
    },
    $nextDates: function () {
        this.$nextDates = $('.cls__nav-right .icon-i16_arrow-right', this.$el);
    },
    showCalendar: function () {
        this.$el.slideDown();
    },
    hideCalendar: function () {
        this.$el.slideUp();
    },
    navigation: function () {
        const self = this;
        return {
            hideAll: function () {
                self.$nextDates.hide();
                self.$previousDates.hide();
            },
            hideLeft: function () {
                self.$previousDates.hide();
            },
            showAll: function () {
                this.showRight();
                self.$previousDates.show();
            },
            showRight: function () {
                self.$nextDates.show();
            },
        };
    },
    addCalendarData: function (data) {
        const self = this;
        const calendarData = self.model.get('calendarData');
        let dateColl;
        let index;
        if (calendarData && calendarData.length) {
            dateColl = _.findWhere(calendarData, { dateStr: data.date.format('YYYY-MM-DD') });
            if (_.isObject(dateColl) && !dateColl.price) {
                index = _.findLastIndex(calendarData, { dateStr: data.date.format('YYYY-MM-DD') });
                calendarData[index].price = data.price;
                this.model.set('calendarData', calendarData);
                this.model.trigger('change:calendarData');
                this.renderSlider();
            }
        }
    },
    getCalendarData: function (params, callback) {
        const tourCriteria = params.searchData;
        const calendarTourCriteria = tourCriteria.clone();
        const self = this;

        this.model.get('searchData').set('checkInDateRange', tourCriteria.get('checkInDateRange'));
        this.model.recompute('expandedDatesObject');

        calendarTourCriteria.set('checkInDateRange', new CheckInDateRangeObjectValue(params.slideMoveDates || this.model.get('expandedDates')));

        const data = {
            ..._.pick(tourCriteriaJsonHydrator(calendarTourCriteria), 'checkInDateRange', 'countries', 'departureCity', 'resorts', 'hotels', 'nightRange', 'meals', 'hotelCategories', 'operators', 'touristGroup'),
            ...setAdditionalMetaOptions(),
        };

        if (!data.nightRange || !data.nightRange.from || !data.nightRange.to) {
            self.track('nightRange');
        }
        const options = {
            url: `${window.appConfig.apiGatewayUrl}/frontend/prices/searchLatest`,
            data,
        };

        if (data.countries && data.countries.length === 1) {
            ajaxRequestManager.abortAll(options);
            if (!params.notCenterCurrent) {
                this.$el.addClass('loading');
            }
            self.navigation().hideAll();
            ajaxRequestManager.getData(options, {
                success: function (responseData, fullData) {
                    let calendarData = fullData.result;
                    if (!calendarData || !calendarData.length) {
                        self.hideCalendar();
                        return;
                    }
                    calendarData = _.map(calendarData, function (dateData) {
                        return {
                            date: moment(dateData.checkindate, 'YYYY-MM-DD'),
                            dateStr: dateData.checkindate,
                            price: Math.round(dateData.price),
                        };
                    });

                    self.successGetCalendarData(calendarData, params);
                    if (_.isFunction(callback)) {
                        callback(calendarData);
                    }
                },
                error: function () {
                    if (_.isFunction(callback)) {
                        callback();
                    }
                },
            });
        } else {
            self.hideCalendar();
        }
    },
    successGetCalendarData: function (calendarData, params) {
        const self = this;
        if (params.notClearCalendarDate) {
            const modelCalendarData = self.model.get('calendarData');
            let index;
            for (const i in calendarData) {
                index = _.findLastIndex(modelCalendarData, { dateStr: calendarData[i].dateStr });
                if (index >= 0) {
                    modelCalendarData[index].price = calendarData[i].price;
                }
            }
            self.model.set('calendarData', modelCalendarData);
            self.model.trigger('change:calendarData');
        } else {
            self.model.set('calendarData', calendarData);
        }
        self.showCalendar();
        self.$el.removeClass('loading');
        self.renderSlider(params);
    },
    dateSelected: function (e) {
        const $dateCol = $(e.currentTarget);
        const dateStr = $dateCol.data('date');
        const date = moment(dateStr, 'YYYY-MM-DD');
        if (!$dateCol.hasClass('disabled') && !$dateCol.find('.cls-d-have-not-tours').length) {
            this.dataLayerAnalyticsEvent($dateCol.hasClass('not-price') ? 'clickEmptyCalendar' : 'clickPriceCalendar');
            this.setActiveCollByDateStr(dateStr);
            this.startNewSearchByDate(date);
        }
    },
    dataLayerAnalyticsEvent(eventName) {
        this.dataLayerAnalytics.generateEvent(eventName, '');
    },
    setActiveCollByDateStr: function (dateStr) {
        this.$calendarData.find('.cls-itu-column.current').removeClass('current');
        this.$calendarData.find('.cls-itu-column[data-date=' + dateStr + ']').addClass('current');
    },
    startNewSearchByDate: function (date) {
        const dateFrom = date;
        const dateTo = dateFrom.clone();
        const checkInDateRange = {
            from: dateFrom._d,
            to: dateTo._d,
        };
        const newCheckInDateRange = new CheckInDateRangeFactory(checkInDateRange);
        this.searchViewModel.set('sortStrategy', 'priceUp');
        this.model.set('selectedDates', newCheckInDateRange);
        this.checkInDateRange.set('model', newCheckInDateRange);
        tourCriteriaService.addTourCriteriaChangedField('checkInDateRange');
        this.preventSearchDataUpdate = true;
        this.parent.formSubmit({
            notCloseEmptySerpBanners: true,
            openBooking: false,
        });
        this.preventSearchDataUpdate = false;
    },
    renderCalendar: function () {
        const html = this.calendarDataTemplate({
            today: moment().startOf('day'),
            calendarMinPrice: this.model.get('calendarMinPrice'),
            calendarMaxPrice: this.model.get('calendarMaxPrice'),
            selectedDates: this.model.get('selectedDates'),
            calendarData: this.model.get('calendarData'),
            emptyDates: this.model.get('emptyDates'),
            dayOfWeek: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
        });
        this.$calendarData.html(html);
        this.$calendarData.find('.cls-itu-column').on('click', $.proxy(this.dateSelected, this));
    },
    changedCalendarData: function () {
        this.renderCalendar();
    },
    changedNightsLabel: function (model, nightsLabel) {
        this.$nightsLabel.text(nightsLabel);
    },
    changedTouristLabel: function (model, text) {
        this.$touristLabel.text(text);
    },
    changedOffset: function (model) {
        this.getCalendarData({
            searchData: model.get('searchData'),
            dontClearMinPrice: true,
        });
    },
    changedSearchData: function (model) {
        this.model.set('offset', 0, { silent: true });
        this.getCalendarData({
            searchData: model.get('searchData'),
        });
    },
    prevDatesAvailableChanged: function (model, prevDatesAvailable) {
        if (this.model.numOfCalendarDays > 15) return;
        if (prevDatesAvailable) {
            this.$previousDates.removeClass('disabled');
        } else {
            this.$previousDates.addClass('disabled');
        }
    },
    changedCalendarMaxPrice: function (model, maxPrice) {
        let label = '';
        const minPrice = this.model.get('calendarMinPrice');

        if (maxPrice === minPrice) {
            this.$maxPriceThing.hide();
            if (!maxPrice) {
                this.$minPriceThing.hide();
            } else {
                this.$minPriceThing.show();
            }
            this.$minPriceThing.addClass('middle');
        } else {
            this.$maxPriceThing.show();
            this.$minPriceThing.show();
            this.$minPriceThing.removeClass('middle');
        }

        if (maxPrice) {
            label = maxPrice.formatNumber();
        }
        this.$maxPriceLabel.text(label);
    },
    changedCalendarMinPrice: function (model, minPrice) {
        let label = '';

        if (minPrice) {
            label = minPrice.formatNumber();
        }
        this.$minPriceLabel.text(label);
    },
    initOuterModelsEvents: function () {
        const self = this;
        this.searchViewModel.on('change:searchData', function (viewModel, searchData) {
            if (!self.preventSearchDataUpdate) {
                self.model.set('searchData', searchData);
                self.model.set('selectedDates', searchData.get('checkInDateRange'));
            } else {
                self.preventSearchDataUpdate = false;
            }
        });
    },
    initModelEvents: function () {
        this.model.on('change:searchData', $.proxy(this.changedSearchData, this));
        this.model.on('change:nightsLabel', $.proxy(this.changedNightsLabel, this));
        this.model.on('change:touristLabel', $.proxy(this.changedTouristLabel, this));
        this.model.on('change:calendarData', $.proxy(this.changedCalendarData, this));
        this.model.on('change:offset', $.proxy(this.changedOffset, this));
        this.model.on('change:prevDatesAvailable', $.proxy(this.prevDatesAvailableChanged, this));
        this.model.on('change:calendarMaxPrice', $.proxy(this.changedCalendarMaxPrice, this));
        this.model.on('change:calendarMinPrice', $.proxy(this.changedCalendarMinPrice, this));
    },
    initDOMEvents: function () {
        const self = this;
        if (this.model.numOfCalendarDays > 15) {
            this.$previousDates.on('click', function () {
                self.$calendarData.animate({
                    left: 0,
                }, 400, function () {
                    const $firstColl = self.$calendarData.find('.cls-itu-range:first .cls-itu-column:first');
                    const lastDateFrom = moment($firstColl.attr('data-date'), 'YYYY-MM-DD');
                    const lastDateTo = lastDateFrom.clone();
                    let
                        minDay = 0;

                    self.getCalendarData({
                        searchData: self.model.get('searchData'),
                        slideMoveDates: (function () {
                            const today = moment().add(1, 'days').startOf('day');
                            if (lastDateFrom.diff(today, 'days') >= 8) {
                                minDay = 8;
                            } else {
                                minDay = lastDateFrom.diff(today, 'days');
                            }
                            return {
                                from: lastDateTo.subtract(minDay, 'days').toDate(),
                                to: lastDateFrom.add(30 - minDay, 'days').toDate(),
                            };
                        }()),
                        notCenterCurrent: true,
                        notMove: !minDay,
                        lastCollIndex: (7 + minDay),
                    });
                });
            });
            this.$nextDates.on('click', function () {
                self.$calendarData.animate({
                    left: (function () {
                        let result = 0;
                        $('.cls-itu-range', self.$el).each(function (index) {
                            const $visible = $(this).find('.cls-itu-column[data-visible=true]:last');
                            if ($visible.length) {
                                result += $visible.nextAll('.cls-itu-column').length;
                            } else if (index > 0) {
                                result += $(this).find('.cls-itu-column[data-visible=false]').length;
                            }
                        });
                        return self.$calendarData.position().left - (result * self.collWith);
                    }()),
                }, 400, function () {
                    const lastDateFrom = moment(self.$calendarData.find('.cls-itu-column[data-visible=false]:last').attr('data-date'), 'YYYY-MM-DD');
                    const lastDateTo = lastDateFrom.clone();
                    self.getCalendarData({
                        searchData: self.model.get('searchData'),
                        slideMoveDates: {
                            from: lastDateFrom.subtract(22, 'days').toDate(),
                            to: lastDateTo.add(8, 'days').toDate(),
                        },
                        notCenterCurrent: true,
                    });
                });
            });
        } else {
            this.$previousDates.on('click', function () {
                let offset;
                if (self.model.get('prevDatesAvailable')) {
                    offset = self.model.get('offset');
                    self.model.set('offset', --offset);
                }
            });
            this.$nextDates.on('click', function () {
                let offset = self.model.get('offset');
                self.model.set('offset', ++offset);
            });
        }
        $(window).resize(function () {
            self.renderSlider();
        });
    },
    $calendarContainer: function () {
        this.$calendarContainer = $('#priceCalendarContainer');
    },
    render: function () {
        this.$calendarContainer.html(this.$el);
    },
    setCurrentPosition: function (params) {
        const { collWith } = this;
        let position = 0;
        let visible = 0;
        const lastCollIndex = params.lastCollIndex || 15;
        const { $cols } = this;

        if (!params.notMove) {
            // Устанавливаем положение слайдера относительно выбранной даты
            for (let i = 0; i < lastCollIndex; i++) {
                if ($cols.eq(i).is('.current') && !params.notCenterCurrent) {
                    break;
                } else if (i >= 7) {
                    position -= collWith;
                    visible++;
                }
            }
        }
        // отмечаем дата параметром видимые и невидимые элементы
        $cols.each(function (index) {
            $(this).attr('data-visible', !(index < visible || index >= (visible + 15)));
        });
        return params.notMove ? 0 : position;
    },
    renderSlider: function (params = {}) {
        if (this.model.numOfCalendarDays <= 15) return;
        this.$cols = $(this.$calendarData.find('.cls-itu-column'));
        const { $calendarData } = this;
        const width = this.createSliderWith();
        const left = this.setCurrentPosition(params);

        $calendarData.css({
            left: left,
            width: width,
        });
        const $firstVisibleColl = this.$calendarData.find('.cls-itu-column[data-visible=true]:first');
        this.navigation()[moment().add(1, 'day').diff(moment($firstVisibleColl.attr('data-date'), 'YYYY-MM-DD'), 'days') ? 'showAll' : 'showRight']();
    },
    createSliderWith: function () {
        const self = this;
        let sliderWidth = 0;
        self.collWith = self.$calendarData.find('.cls-itu-column:first').outerWidth();
        self.$calendarData.find('.cls-itu-range').each(function () {
            const width = $(this).find('.cls-itu-column').length * self.collWith;
            sliderWidth += width;
            $(this).width(width);
        });
        this.model.set('sliderWidth', sliderWidth);
        return sliderWidth;
    },
    getMinPriceDate: function () {
        const price = this.model.get('calendarMinPrice') || this.model.get('calendarMaxPrice') || null;
        const calendarData = this.model.get('calendarData');
        return price ? _.findWhere(calendarData, { price: price }).date : null;
    },
    setDateNotTours: function (date) {
        this.model.get('emptyDates').push(date);
        this.model.set('mobileViewDateCheck', false);
        if (this.model.get('calendarData') && this.model.get('calendarData').length) {
            this.model.trigger('change:calendarData');
            this.renderSlider();
        }
    },
    track: function (/* type */) {
        /* var message;
        switch (type){
            case "nightRange": message = "undefined data.nightRange";break;
            default : message = "RequestToPriceStatisticAfterUserSlideMoving"
        }
        if(typeof trackJs !== 'undefined'){
            trackJs.track(message);
        } */
    },
    initialize: function (options) {
        this.model = new PriceCalendarModel();
        this.dataLayerAnalytics = new DataLayerAnalytics();
        this.model.numOfCalendarDays = options.numOfCalendarDays || this.model.numOfCalendarDays;
        this.$calendarContainer();
        this.render();
        this.parent = options.parent;
        this.searchViewModel = this.parent.view.model;
        this.checkInDateRange = this.parent.model.get('checkInDateRange');

        this.$nightsLabel();
        this.$touristLabel();
        this.$minPriceLabel();
        this.$minPriceThing();
        this.$maxPriceThing();
        this.$maxPriceLabel();
        this.$calendarData();
        this.$previousDates();
        this.$nextDates();
        this.initModelEvents();
        this.initOuterModelsEvents();
        this.initDOMEvents();
    },
});

export default PriceCalendarView;
